import { siteInfo } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20patterns%20with%20warm%20golden%20amber%20and%20soft%20cream%20gradients%2C%20modern%20digital%20connectivity%20theme%2C%20flowing%20curves%20and%20nodes%2C%20minimalist%20tech%20background%2C%20elegant%20atmospheric%20design%2C%20no%20text%20or%20labels%2C%20clean%20professional%20aesthetic%20with%20subtle%20light%20effects&width=1600&height=900&seq=hero-bg-main&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6 text-center py-20">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-white/15 backdrop-blur-sm rounded-full border border-white/20 mb-8">
          <i className="ri-verified-badge-line text-accent-400 text-sm"></i>
          <span className="text-white/90 text-xs md:text-sm">官方认证 · 安全正版下载渠道</span>
        </div>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6 max-w-4xl mx-auto">
          008pg国际App官方下载
          <br />
          <span className="text-primary-300">安全 · 稳定 · 值得信赖</span>
        </h1>

        <p className="text-white/75 text-base md:text-lg max-w-2xl mx-auto mb-10 leading-relaxed">
          提供最新版本安全正版安装包，支持iOS和Android系统，快速下载即可体验流畅稳定的008pg国际平台。官方认证渠道，全方位保障您的账户安全。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={siteInfo.downloadLinks.ios}
            className="group w-full sm:w-auto inline-flex items-center gap-3 px-8 py-4 bg-white text-foreground-900 rounded-full font-medium text-base whitespace-nowrap hover:bg-primary-50 transition-all duration-300 cursor-pointer"
          >
            <i className="ri-apple-fill text-xl group-hover:text-primary-600 transition-colors"></i>
            <div className="text-left">
              <div className="text-xs text-foreground-500">Download on the</div>
              <div className="text-sm font-semibold">App Store</div>
            </div>
          </a>

          <a
            href={siteInfo.downloadLinks.android}
            className="group w-full sm:w-auto inline-flex items-center gap-3 px-8 py-4 bg-primary-500 text-background-50 rounded-full font-medium text-base whitespace-nowrap hover:bg-primary-600 transition-all duration-300 cursor-pointer"
          >
            <i className="ri-android-fill text-xl"></i>
            <div className="text-left">
              <div className="text-xs text-background-50/70">Download for</div>
              <div className="text-sm font-semibold">Android</div>
            </div>
          </a>
        </div>

        <div className="mt-12 flex items-center justify-center gap-8">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-white">500万+</div>
            <div className="text-xs text-white/60 mt-1">全球用户</div>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-white">98.5%</div>
            <div className="text-xs text-white/60 mt-1">用户好评</div>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-white">80+</div>
            <div className="text-xs text-white/60 mt-1">覆盖国家</div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-s-line text-white/50 text-2xl"></i>
      </div>
    </section>
  );
}